import { Helmet } from "react-helmet";

export const AmazonPixelBaseCode = (props) => {
    console.log('Amazon Base Code');
    if (props.product === undefined)
        return '';

    let product = props.product.toString().toLowerCase();
    let eventName = '';

    if (product === 'membershiprewardscreditcard')
        eventName = 'Microsite_AboutYou_MRCC';
    else if (product === 'platinumtravelcreditcard')
        eventName = 'Microsite_AboutYou_PlatTravel';
    else if (product === 'smartearncreditcard')
        eventName = 'Microsite_AboutYou_SECC';
    else if (product === 'platinumcard')
        eventName = 'Microsite_AboutYou_Platcharge';
    else if (product === 'platinumreservecreditcard')
        eventName = 'Microsite_AboutYou_Platreserve';

    if (eventName !== '')
        return (
            <Helmet>
                <script>
                    {` 
                        !function(w,d,s,t,a){if(w.amzn)return;w.amzn=a=function(){w.amzn.q.push([arguments, (new Date).getTime()])};a.q=[];a.version="0.0";s=d.createElement("script");s.src="https://c.amazon-adsystem.com/aat/amzn.js";s.id="amzn-pixel";s.async=true;t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t)}(window,document);
                        amzn("setRegion", "EU");
                        amzn("addTag", "cde810db-37a2-4691-a894-a329ab99d97c");
                        amzn("trackEvent", "Microsite_PageView");
                        amzn('trackEvent', '${eventName}');
                    `}
                </script>
                <noscript>
                    {`<img src="https://aax-eu.amazon-adsystem.com/s/iu3?pid=cde810db-37a2-4691-a894-a329ab99d97c&event=${eventName}" width="1" height="1" border="0" />` }
                </noscript>
            </Helmet>
        );

}

export const AmazonPixelAboutYouSubmitted = (selectedProduct) => {
    console.log('Amazon About You Submitted');
    if (selectedProduct === undefined || selectedProduct === null) {
        return '';
    }
    else {
        let product = selectedProduct.toLowerCase();
        let eventName = '';

        if (product === 'membershiprewardscreditcard')
            eventName = 'Microsite_AddInformation_stage1lead_MRCC';
        else if (product === 'platinumtravelcreditcard')
            eventName = 'Microsite_AddInformation_stage1lead_PlatTravel';
        else if (product === 'smartearncreditcard')
            eventName = 'Microsite_AddInformation_stage1lead_SECC';
        else if (product === 'platinumcard')
            eventName = 'Microsite_AddInformation_stage1lead_Platcharge';
        else if (product === 'platinumreservecreditcard')
            eventName = 'Microsite_AddInformation_stage1lead_Platreserve';

        if (eventName !== '' && window.amzn !== 'undefined')
            window.amzn('trackEvent', eventName);
    }
}

export const AmazonPixelAdditionalInfoClicked = (selectedProduct) => {
    console.log('Amazon Additional Info Clicked');
    if (selectedProduct === undefined)
        return '';
    let product = selectedProduct.toLowerCase();
    let eventName = '';

    if (product === 'membershiprewardscreditcard')
        eventName = 'Microsite_AddInformation_MRCC';
    else if (product === 'platinumtravelcreditcard')
        eventName = 'Microsite_AddInformation_PlatTravel';
    else if (product === 'smartearncreditcard')
        eventName = 'Microsite_AddInformation_SECC';
    else if (product === 'platinumcard')
        eventName = 'Microsite_AddInformation_Platcharge';
    else if (product === 'platinumreservecreditcard')
        eventName = 'Microsite_AddInformation_Platreserve';

    if (eventName !== '' && window.amzn !== 'undefined')
        window.amzn('trackEvent', eventName);
}

export const AmazonCardOption = (props) => {
    console.log('Amazon Card Option');
    if (props.product === undefined)
        return '';
    let product = props.product.toString().toLowerCase();
    let eventName = '';

    if (product === 'membershiprewardscreditcard')
        eventName = 'Microsite_applicationcomplete_stage2success_MRCC';
    else if (product === 'platinumtravelcreditcard')
        eventName = 'Microsite_applicationcomplete_stage2success_PlatTravel';
    else if (product === 'smartearncreditcard')
        eventName = 'Microsite_applicationcomplete_stage2success_SECC';
    else if (product === 'platinumcard')
        eventName = 'Microsite_applicationcomplete_stage2success_Platcharge';
    else if (product === 'platinumreservecreditcard')
        eventName = 'Microsite_applicationcomplete_stage2success_Platreserve';

    if (eventName !== '' && window.amzn !== 'undefined')
        window.amzn('trackEvent', eventName);
}

export const AmazonCardRejected = (props) => {
    console.log('Amazon Card Reject');
    if (props.product === undefined)
        return '';
    let product = props.product.toString().toLowerCase();
    let eventName = '';

    if (product === 'membershiprewardscreditcard')
        eventName = 'Microsite_applicationcomplete_stage2reject_MRCC';
    else if (product === 'platinumtravelcreditcard')
        eventName = 'Microsite_applicationcomplete_stage2reject_PlatTravel';
    else if (product === 'smartearncreditcard')
        eventName = 'Microsite_applicationcomplete_stage2reject_SECC';
    else if (product === 'platinumcard')
        eventName = 'Microsite_applicationcomplete_stage2reject_Platcharge';
    else if (product === 'platinumreservecreditcard')
        eventName = 'Microsite_applicationcomplete_stage2reject_Platreserve';

    if (eventName !== '') { 
        window.amzn('trackEvent', eventName);
    }
}